@if (!editMode) {
  <a
    (click)=enabledEditMode()
    (keydown.space)=enabledEditMode()
    (keydown.enter)=enabledEditMode()
   [ngClass]="{
   'editable': true,
   'inlineEdit': true,
   'notAllowed': disabledFlag
   }"
    aria-label='click to edit'
    tabindex="0"
    >
    {{ (data | truncate: [truncate]) || defaultPlaceHolder }}
    @if (templateEdit) {
      <span class="material-icons edit-template-icon">create</span>
    }
  </a>
}
@if (editMode) {
  <input
    class='inlineEditText'
    appAutofocus
    [disabled]="disabledFlag"
    (keyup.enter)="onFocusOut()"
    (focusout)="onFocusOut()"
    (keydown.enter)='$event.target.blur()'
    [(ngModel)]='data'
    (focusin)="startEdit()"
    (keydown.escape)="undo()"
    >
}
